module.exports = __webpack_public_path__ + "static/media/circle_do.0a2124be.svg";